// @flow
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import React from "react";

type Props = {
	info: string
};

const FieldInfoPopupWrapper = (props: Props) => {
	return (
		<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
			{props.children}
			<Tooltip
				title={<span style={{
					fontFamily: "Arial, sans-serif",
					fontSize: "14px"
				}}>{props.info}</span>}
				placement="left"
				arrow
				enterTouchDelay={0}
				slotProps={{
					tooltip: {
						sx: {
							maxWidth: 200,          // limit width
							whiteSpace: 'normal',   // allow wrapping
							fontSize: 14,
						},
					}
				}}
			>
				<IconButton size="medium">
					<InfoOutlinedIcon fontSize="medium"/>
				</IconButton>
			</Tooltip>
		</div>
	);
};

export default FieldInfoPopupWrapper